import { sel } from '../utils'
import './cardBlur.css'
// return

// gsap.registerPlugin(ScrollTrigger)
export default function CardBlur() {
  const testimonials$ = sel('.exec-card')

  if (!testimonials$) return
  // console.log('Init testimonial slider')

  const ua = navigator.userAgent
  const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)
  if (isSafari) {
    testimonials$.style.setProperty('--card-blur', '0px')
  }

  // ===== Utilities =====
  const rootFont = () => parseFloat(getComputedStyle(document.documentElement).fontSize)
  const toPx = (len, base = rootFont()) => {
    if (typeof len === 'number') return len
    const v = String(len).trim()
    if (v.endsWith('rem')) return parseFloat(v) * base
    if (v.endsWith('px')) return parseFloat(v)
    return parseFloat(v) || 0 // fallback assumes px
  }
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n))
  const setAttr = (el, name, val) => el.setAttribute(name, String(val))
  const prec = (n) => Number(n.toFixed(6))

  const maskW$ = sel('.svg-mask defs')
  const mask$ = maskW$?.sel('#cutout')
  // const hole = document.querySelector('#cutout-1 #hole')
  if (!mask$) return

  const section = ['.exec-proof-sec']
  const item = '.exec-card:not(.is--small)'
  section.forEach((sec, i) => {
    const section$ = sel(`${sec}`)
    const item$ = section$?.sel(item)
    if (!item$) return

    const newMask$ = mask$.cloneNode(true)
    const newHole$ = newMask$.sel('#hole')
    const maskId = `cutout-${i + 1}`
    const holeId = `hole-${i + 1}`
    newMask$.setAttribute('id', maskId)
    newHole$.setAttribute('id', holeId)

    maskW$.appendChild(newMask$)

    // const item$ = sel('.exec-card')
    const hole = sel(`#${maskId} #${holeId}`)

    function updateMaskFractions() {
      if (!item$ || !hole) return
      const { width: W, height: H } = item$.getBoundingClientRect()
      if (!W || !H) return

      const cs = getComputedStyle(item$)
      const insetX = toPx(cs.getPropertyValue('--inset-x'))
      const insetY = toPx(cs.getPropertyValue('--inset-y'))
      const radius = toPx(cs.getPropertyValue('--radius'))
      // console.log(insetX)

      // Convert to 0..1 fractions for objectBoundingBox coords
      const xFrac = clamp(insetX / W, 0, 0.4999)
      const yFrac = clamp(insetY / H, 0, 0.4999)
      const wFrac = clamp(1 - 2 * xFrac, 0, 1)
      const hFrac = clamp(1 - 2 * yFrac, 0, 1)

      // Keep corners visually circular after non-uniform scaling:
      // rx = r / W  and  ry = r / H  (cap at half side length per axis)
      let rxFrac = radius / W
      let ryFrac = radius / H
      rxFrac = Math.min(rxFrac, wFrac / 2)
      ryFrac = Math.min(ryFrac, hFrac / 2)

      // Write fractions to the mask rect
      setAttr(hole, 'x', prec(xFrac))
      setAttr(hole, 'y', prec(yFrac))
      setAttr(hole, 'width', prec(wFrac))
      setAttr(hole, 'height', prec(hFrac))
      setAttr(hole, 'rx', prec(rxFrac))
      setAttr(hole, 'ry', prec(ryFrac))
    }

    // Run now and on resize / font load (rem changes)
    const ro = new ResizeObserver(updateMaskFractions)
    ro.observe(item$)
    window.addEventListener('resize', updateMaskFractions, { passive: true })
    if (document.fonts?.ready) document.fonts.ready.then(updateMaskFractions)
    updateMaskFractions()
  })
}
